import { toTitleCase } from 'lib/Helper'

const getCardResponse = (rawData: any) => {
  const result = rawData?.data?.data
  const transformedData: ResponseType = result?.map((engagement: any) => {
    const { name, percentage, value } = engagement || {}
    return {
      value,
      percentage,
      name: toTitleCase(name),
      label: `${value} (${percentage})`,
    }
  })
  return {
    data: transformedData,
    info: rawData?.data?.meta?.info,
  }
}

const visitorEngagementFormattedResponses = {
  getCardResponse,
}

export default visitorEngagementFormattedResponses
